import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux'
import type {RootState, AppDispatch} from './store'
import {useEffect, useRef, useState} from "react";
import {DateTime} from "luxon";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const useRefreshInterval = (callback,
                                   delay = 1000 * 60 * 5) => {
    let intervalId = null;
    const currentTime = DateTime.now()
    const nextExecutionMinutes = currentTime.get("minute") < 30 ? 33 : 3;
    const nextExecutionHour = nextExecutionMinutes === 33 ? currentTime.get("hour") : currentTime.plus({hour: 1}).get("hour");
    const initialNextExecution = currentTime.set({minute: nextExecutionMinutes, hour: nextExecutionHour})

    const [timeToExecute, setTimeToToExecute] = useState<DateTime>(initialNextExecution);
    const timeToExecuteRef = useRef<DateTime>(initialNextExecution)

    useEffect(() => {
        timeToExecuteRef.current = timeToExecute;
    });

    useEffect(() => {
        intervalId = setInterval(() => {
            const intervalTime = DateTime.now();
            if(intervalTime>timeToExecuteRef.current){
                callback();
                const nextExecution = timeToExecute.plus({minute:30});
                setTimeToToExecute(nextExecution);
            }
        }, delay)

        return () => {
            clearInterval(intervalId)
        };
    }, []);


    ;
    return null
}